var render, staticRenderFns
import script from "./tag-input.vue?vue&type=script&lang=js"
export * from "./tag-input.vue?vue&type=script&lang=js"
import style0 from "./tag-input.vue?vue&type=style&index=0&id=85d38932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports